import tw, { styled } from 'twin.macro';

export const StyledSelectSSRPlaceholder = styled.div<{ isDisabled?: boolean }>`
  ${tw`min-h-[48px]`}

  ${({ isDisabled }) => !isDisabled && tw`bg-neutrals-n2 rounded-md`}
`;

export const StyledDropdownIndicator = styled.div`
  ${tw`w-[24px] h-[24px]`}
  ${tw`relative`}

  .icon {
    ${tw`w-[24px] h-[24px]`}
    ${tw`absolute left-[50%] top-[50%]`}
    transform: translate(-50%, -50%);
  }
`;

export const StyledReactSelect = styled.div<{ isDisabled?: boolean; hasError?: boolean }>`
  ${({ isDisabled }) => isDisabled && tw`cursor-not-allowed opacity-50`}

  .language-switcher .react-select__control {
    ${tw`border-secondary-s1`}

    &.react-select__control--menu-is-open {
      ${tw`rounded-t-none rounded-b-[8px]`}
      ${tw`border-secondary-s1 hover:border-secondary-s1`}
      .react-select__indicator {
        ${tw`rotate-0`}
      }
    }

    .react-select__indicator {
      ${tw`rotate-180`}
    }
  }

  .react-select__control {
    ${tw`shadow-none`}
    ${tw`cursor-pointer`}
    ${tw`border rounded-[8px] border-ui-colours-ui3`}
    ${tw`bg-neutrals-n1`}
    ${tw`px-2 py-[12px]`}
    ${({ hasError }) => hasError && tw`border-primary-p2`}

    &:has(.react-select__value-container--is-multi.react-select__value-container--has-value) {
      ${tw`py-1`}
    }

    &.react-select__control--is-focused,
    &.react-select__control--menu-is-open {
      ${tw`border-neutrals-n6 hover:border-neutrals-n6`}
    }

    &.react-select__control--menu-is-open {
      ${tw`rounded-t-[6px] rounded-b-none`}

      .react-select__indicator {
        ${tw`rotate-180`}
      }
    }

    .react-select__indicator-separator {
      ${tw`hidden`}
    }

    .react-select__value-container {
      ${tw`p-0`}
      ${tw`font-inter font-regular`}
      ${tw`text-body-s`}
      ${tw`leading-6`}

      .react-select__input-container {
        ${tw`m-0`}
        ${tw`p-0`}
      }
    }

    .react-select__indicator {
      ${tw`p-0`}
      ${tw`text-neutrals-n9`}
    }

    .react-select__multi-value {
      ${tw`px-1 py-[6px]`}
      ${tw`bg-neutrals-n3`}
      ${tw`font-inter font-regular`}
      ${tw`text-body-s text-neutrals-n7`}
      ${tw`flex gap-[12px]`}
      ${tw`my-0`}
      ${tw`rounded-[4px]`}

      .react-select__multi-value__label, .react-select__multi-value__remove {
        ${tw`p-0`}
      }

      .react-select__multi-value__remove {
        ${tw`h-[21px]`}
        ${tw`text-primary-p1`}
      }
    }
  }

  .language-switcher .react-select__menu {
    ${tw`border border-b-0 border-secondary-s1 rounded-t-[6px] rounded-b-none`}
  }

  .react-select__menu {
    ${tw`shadow-none`}
    ${tw`m-0`}
    ${tw`border border-t-0 border-neutrals-n6 rounded-t-none rounded-b-[6px]`}
    ${tw`bg-neutrals-n1`}

    .react-select__menu-list {
      ${tw`p-0`}

      .react-select__option {
        ${tw`cursor-pointer`}
        ${tw`font-inter font-regular`}
        ${tw`text-body-s text-neutrals-n9`}
        ${tw`pl-2 pr-5`}
        ${tw`hover:bg-neutrals-n2 focus:bg-neutrals-n2 active:bg-neutrals-n2`}

        &.react-select__option--is-focused, &.react-select__option--is-selected {
          ${tw`bg-neutrals-n2`}
        }
      }
    }
  }
  .react-select__placeholder {
    ${tw`flex flex-col justify-center self-stretch grow shrink-0 basis-0`}
    ${tw`font-inter font-regular`}
    ${tw`text-mobile-heading-xxs text-neutrals-n7`}
  }
`;
